import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// PrimeNG Components
import { DataViewModule } from 'primeng/dataview';
import { PanelModule } from 'primeng/panel';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputMaskModule } from 'primeng/inputmask';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';

// Module
import { ListaRoutingModule } from './lista-routing.module';
import { ComponentsModule } from '../components/components.module';

// Application Components
import { ListadoTiposEstablecimientosComponent } from './lista-inscripcion-establecimientos/listado-tipos-establecimientos.component';
import { ListadoTiposPoderesComponent } from './lista-inscripcion-poderes/listado-tipos-poderes.component';
import { ListaProductosFarmaceuticosComponent } from './lista-productos-farmaceuticos/lista-productos-farmaceuticos.component';
import { ListaDispositivosComponent } from './lista-inscripcion-dispositivos/lista-dispositivos.component';
import { ListaProductosCosmeticosComponent } from './lista-productos-cosmeticos/lista-productos-cosmeticos.component';
import { ListaInscripcionContratosComponent } from './lista-inscripcion-contratos/lista-inscripcion-contratos.component';
import { ListaQuimicosComponent } from './lista-productos-quimicos/lista-quimicos.component';
import { PostRegistroEstablecimientosComponent } from './lista-inscripcion-establecimientos/post-registro/post-registro-establecimientos.component';
import { PostRegistroPoderesComponent } from './lista-inscripcion-poderes/post-registro/post-registro-poderes.component';
import { PostRegistroProductosComponent } from './lista-productos/post-registro/post-registro-productos.component';
import { ListaInscripcionPublicidadComponent } from './lista-inscripcion-publicidad/lista-inscripcion-publicidad.component';
import {ListadoLotesVacuna} from './lista-lotes-vacunas/lista-lotes-vacunas.component';
import { RecolecionDatosMercado } from './lista-datos-mercado/lista-datos-mercado.component';
import { ListaRegistroEstupefacientesComponent } from './lista-datos-estupefacientes/lista-datos-estupefacientes.component';
import { PostRegistroContratosComponent } from './lista-inscripcion-contratos/post-registro-contratos/post-registro-contratos.component';
import { ListaAnalisisLaboratoriosComponent } from './lista-analisis-laboratorio/listado-analisis-laboratorio.component';
import { EntidadesComponent } from './entidades/entidades.component';
import { ListadoAlimentosYBebidas } from './lista-alimentos-bebidas/lista-alimentos-bebidas.component';
import { ListaEntidadesComponent } from './lista-entidades/lista-entidades.component';
import { DialogModule } from 'primeng/dialog';
import { Veterinarios } from './lista-veterinarios/lista-veterinarios.component';



@NgModule({
  declarations: [
    ListaProductosFarmaceuticosComponent,
    ListaDispositivosComponent,
    ListaProductosCosmeticosComponent,
    ListaInscripcionContratosComponent,
    ListaQuimicosComponent,
    ListadoTiposEstablecimientosComponent,
    PostRegistroEstablecimientosComponent,
    ListadoTiposPoderesComponent,
    PostRegistroPoderesComponent,
    PostRegistroProductosComponent,
    ListaInscripcionPublicidadComponent,
    ListadoLotesVacuna,
    RecolecionDatosMercado,
    ListaRegistroEstupefacientesComponent,
    PostRegistroContratosComponent,
    ListaAnalisisLaboratoriosComponent,
    EntidadesComponent,
    ListadoAlimentosYBebidas,
    ListaEntidadesComponent,
    Veterinarios,
  ],
  imports: [
    CommonModule,
    ListaRoutingModule,
    DataViewModule,
    PanelModule,
    BreadcrumbModule,
    ComponentsModule,
    ButtonModule,
    TableModule,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    InputMaskModule,
    ButtonModule,
    FileUploadModule,
    RadioButtonModule,
    CalendarModule,
    CardModule,
    ReactiveFormsModule,
    FormsModule,
    AccordionModule,
    TableModule,
    DialogModule,
  ]
})
export class ListaModule { }